import React from 'react'

const Exp = () => (
    <div className="container-fluid p-0">
        <section id="contact">
            <div className="inner">
                <section className="pl-2">
                    <div className="pf d-none d-sm-block">
                        <h1 className="display-4"><strong>Experiência Profissional</strong></h1>
                    </div>
                    <div className="pf d-block d-sm-none">
                        <h1 className="display-4"><strong>Experiência </strong>
                            <p className="mb-0"><strong>Profissional</strong></p>
                        </h1>
                    </div>

                    <dl>
                        <dt><b>Especialista em Redação</b></dt>
                        <dd>
                            <span>Natura – São Paulo | SP</span>
                            <p>Agosto | 2021 – até o momento</p>
                            <p>Responsável pela criação, desdobramentos e supervisão do conteúdo verbal da equipe para os canais digitais e diferentes públicos da empresa (consultoras e consumidores), de acordo com as campanhas globais, do Hub de Campanhas da Natura Brasil.</p>
                        </dd>
                        <dt><b>Redatora Sênior</b></dt>
                        <dd>
                            <span>Black Office - São Paulo | SP</span>
                            <p>Março | 2020 - Agosto | 2021</p>
                            <p>Elaboração e apresentação de campanhas publicitárias on e off, do conceito aos desdobramentos. Planejamento e gerenciamento de redes sociais e coordenação de conteúdo.</p>
                        </dd>
                        <br />
                        <br />
                        <dt><b>Redatora Plena</b></dt>
                        <dd>
                            <span>Tugarê | CDM – São Paulo | SP</span>
                            <p> Novembro | 2019 – Março | 2020</p>
                            <p>Elaboração e apresentação de campanhas publicitárias on e off, do conceito aos desdobramentos. Gerenciamento de redes sociais.</p>
                        </dd>
                        <br />
                        <br />
                        <dt><b>Redatora</b></dt>
                        <dd>
                            <span>Vivancy – São Paulo | SP</span>
                            <p>Outubro | 2017 – Abril | 2018</p>
                            <p>Elaboração e apresentação de campanhas publicitárias on e off, do conceito aos desdobramentos. Gerenciamento de redes sociais.</p>
                        </dd>
                        <br />
                        <br />
                        <dt><b>Redatora</b></dt>
                        <dd>
                            <span>5 ERA – São Paulo | SP</span>
                            <p>Agosto | 2017 – Outubro | 2017 </p>
                            <p>Produção de conteúdo para mídias sociais; curadoria de pautas; gerenciamento de comunidades.</p>
                        </dd>
                        <br />
                        <br />
                    </dl>
                </section>

                <section className="split">
                    <section className="skills pl-3">
                        <h1 className="pf display-4"><strong>Skills</strong></h1>
                        <ul className="alt">

                            <li> <i className="fa fa-square mr-1" />Escrita </li>
                            <li> <i className="fa fa-square mr-1" />Leitura </li>
                            <li> <i className="fa fa-square mr-1" />Inglês </li>
                            <li> <i className="fa fa-square mr-1" />Social Media </li>
                            <li> <i className="fa fa-square mr-1" />Marketing 360° </li>
                            <li> <i className="fa fa-square mr-1" />Gestão de Projetos </li>
                            <li> <i className="fa fa-square mr-1" />Comunicação Visual</li>
                            <li> <i className="fa fa-square mr-1" />Styling</li>
                            <li> <i className="fa fa-square mr-1" />Gestão de Equipe</li>

                        </ul>
                    </section>
                    <section className="formation pl-3">
                        <h1 className="pf display-4"><strong>Formação</strong></h1>
                        <dl>
                            <dt>Manu Carvalho</dt>
                            <dd>
                                <p><strong>Consultoria de Moda Clássico e Avançado</strong>
                                    <br />
                                    <span>2021</span>
                                </p>
                            </dd>
                            <dt>Manu Carvalho</dt>
                            <dd>
                                <p><strong>Truques de Styling</strong>
                                    <br />
                                    <span>2021</span>
                                </p>
                            </dd>    
                            <dt>Casa das Rosas</dt>
                            <dd>
                                <p><strong>CLIPE - Curso Livre de Preparação do Escritor</strong>
                                    <br />
                                    <span>2020 | 2021</span>
                                </p>
                            </dd>
                            <dt>Farage.Inc.</dt>
                            <dd>
                                <p><strong>Básico com Borogodó</strong>
                                    <br />
                                    <span>2020</span>
                                </p>
                            </dd>
                            <dt>São Paulo Digital School</dt>
                            <dd>
                                <p><strong>Métricas, Mensurações e Otimizações</strong>
                                    <br />
                                    <span>2017</span>
                                </p>

                            </dd>
                            <dt>ESPM - E. S. de Propaganda e Marketing</dt>
                            <dd>
                                <p><strong>Atualização em Mídias Sociais</strong>
                                    <br />
                                    <span>2017</span>
                                </p>

                            </dd>
                            <dt>CUCA - Escola de Criativos</dt>
                            <dd>
                                <p><strong>Redação Publicitária</strong>
                                    <br />
                                    <span>2017</span>
                                </p>

                            </dd>
                            <dt>Senac Brasil</dt>
                            <dd>
                                <p><strong>Comunicação Visual</strong>
                                    <br />
                                    <span>2015 | 2016</span>
                                </p>

                            </dd>
                            <dt>Centro Universitário de Brasília</dt>
                            <dd>
                                <p><strong>Direito</strong>
                                    <br />
                                    <span>2009 | 2013</span>
                                </p>

                            </dd>
                        </dl>
                    </section>
                </section>
                {/* </div> */}

                {/* <div className="col-7"> */}
                {/* </div> */}
                {/* </div> */}
            </div>
        </section>
    </div>
)

export default Exp
